import dotProp from "dot-prop";
import { getDossiersOfEmployment } from "../selectors/dossiers";

const consultationSchema = function(state, props) {

  const calendarId = dotProp.get(state, `entities.event.byId.${props.entityId}.calendarId`)
  const practionerId = dotProp.get(state, `entities.calendar.byId.${calendarId}.responsibleId`)

  return {
    "practionerId": {
      "ui:widget": "hidden"
    },
    "receiptId": {
      "ui:widget": "hidden"
    },
    "calendarId": {
      "ui:widget": "hidden"
    },
    "noInvoice": {
      "ui:widget": "hidden"
    },
    "dossierId":{
      "ui:field": "PaginatedSelectorField",
      "ui:options": {
        width: 6,
        "entityName": "dossier",
        "displayAttribute": (dossier) => `${dossier.patient && dossier.patient.firstName} ${dossier.patient && dossier.patient.lastName}`,
        "selector": getDossiersOfEmployment('consultationForm', practionerId),
      }
    },
    "consultationTypeId":{
      "ui:field": "SelectorField",
      "ui:options": {
        width: 6,
        "entityName": "consultationType",
        "displayAttribute": (type) => `${type.name}`
      }
    },
    "locationId":{
      "ui:field": "SelectorField",
      "ui:options": {
        width: 6,
        "entityName": "location",
        "displayAttribute": (location) => `${location.name}`
      }
    }
  }
}

export default consultationSchema;
